import {RootState} from '../../store';
import {Price} from './types';

export const selectionSelector = (state: RootState): Record<string, Price> =>
    state['prices'].selection as Record<string, Price>;
